import { useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from './useAxiosPrivate';
import useUtilities from './useUtilities';

const useGetRequest = ({url,propertyName}) => {
    const [data, setData] = useState(null);
    const {i18n}=useTranslation();
    const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const getData = async () => {
        setBackdropOpen(true);
        try {
            console.log('url',url);
            const response = await axiosPrivate.get(url);
            setBackdropOpen(false);
            console.log(response);
            if(propertyName)
                setData(response?.data?.[propertyName]);
            else setData(response?.data);
            // setSnackBarMessage(response?.data?.message);
            // setOpenSnackBar(true);
        } catch (error) {
            setBackdropOpen(false);
            console.log(error.response?.status,error.response?.data.error);
            setSnackBarMessage(i18n.t(error.response?.data.error));
            setOpenSnackBar(true);
        }
    };
    const refresh = async () => {
        getData();
    };
    useEffect(() => {
        if (url) {
            getData();
        }
    }, [url,propertyName]);
    return {data,setData,refresh};
};

export default useGetRequest;